// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": true,
    "raw": "v2.0.19-2-g687ce496-dirty",
    "hash": "g687ce496",
    "distance": 2,
    "tag": "v2.0.19",
    "semver": {
        "options": {
            "loose": false,
            "includePrerelease": false
        },
        "loose": false,
        "raw": "v2.0.19",
        "major": 2,
        "minor": 0,
        "patch": 19,
        "prerelease": [],
        "build": [],
        "version": "2.0.19"
    },
    "suffix": "2-g687ce496-dirty",
    "semverString": "2.0.19+2.g687ce496",
    "version": "2.0.19",
    "branch": "dev",
    "date": "2025-06-25T08:00:48.540Z"
};
/* tslint:enable */
